jQuery(document).ready(function ($) {
    $('.header_20 .header-slider').slick({
        centerMode: true,
        centerPadding: '5%',
        slidesToShow: 1,
        infinite: true,
        dots: true,
        arrows: true,
        autoplay: false,
        autoplaySpeed: 5000,
    });

    // $(".header_20 .image-link-image").hover(function() {
    //     if ($(".header_20 .image-link-image").not(this).hasClass("active")){
    //         $(".header_20 .image-link-image").not(this).removeClass("active");
    //         $(".header_20 .alert").not(this).removeClass("active");
    //         $(this).addClass("active");
    //         $(this).siblings().addClass("active");
    //     }
    //     else {
    //         $(this).toggleClass("active");
    //         $(this).siblings().toggleClass("active");
    //     }
    // });

  if ($(".header-slider").length > 0) {
    $(".header-slider .slick-arrow").attr("lang", 'de');
    $(".header-slider .slick-next").attr("aria-label", 'Weiter');
    $(".header-slider .slick-prev").attr("aria-label", 'Zurück');
  }


});


